import React from 'react';

import cn from '~/utils/cn';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title?: string;
  description?: React.ReactNode;
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon, title = 'No items', description, className }) => {
  return (
    <div className={cn('flex h-full w-full flex-col items-center justify-center p-24 text-blue-950', className)}>
      {icon ? <div className="mb-16">{icon}</div> : null}
      <div className="text-grey-800 mb-8 text-center text-sm font-medium">{title}</div>
      {description && <p className="text-center text-sm">{description}</p>}
    </div>
  );
};

export default EmptyState;
